import React from 'react';
import AddressShowBox from "./AddressShowBox";
import CartManager from "../../../managers/cartManager/cartManager";
import hash from 'object-hash';

function SelectSavedAddress({addresses, onSubmit}) {
    const shipping = CartManager.getShipping();
    const handleSubmit = (key) => {
        CartManager.changeAddress(addresses[key]);
        onSubmit();
    }

    const getSelected = (key) => {
        return shipping.addressType === 'saved' && hash(shipping.address) === hash(addresses[key]);
    }

    return (
        <>
            {Object.keys(addresses).map(key => <AddressShowBox key={key} address={addresses[key]} withButton
                                                               onClick={() => handleSubmit(key)}
                                                               selected={getSelected(key)}/>
            )}
        </>
    );
}

export default SelectSavedAddress;
